import React, { useState } from "react";
import MainCalculatorsList from "./CountriesMainCalculatorsList/SyriaMainCalculator";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة البنزين والمازوت والغاز في سوريا - احسب تكلفة المحروقات";
const DESCRIPTION =
  "احسب تكلفة البنزين والمازوت والغاز بدقة. حاسبة المحروقات تساعدك على حساب البنزين لسيارتك وتكلفة المازوت والغاز المنزلي بالأسعار الرسمية الجديدة";
const KEYWORDS = "حاسبة البنزين, حساب البنزين, حساب المازوت, حساب الغاز, أسعار البنزين سوريا, أسعار المازوت, أسعار الغاز المنزلي, تكلفة الوقود, حاسبة المحروقات";
const OG_URL =
  "https://do-calculate.com/calculator/ar/countries/SY/calculators-list/fuel-calculator/";
// الأسعار الرسمية (بالليرة السورية الجديدة)
const FUEL_PRICES = {
  gasoline90: { price: 102, priceOld: 10200, name: "بنزين 90", unit: "لتر", emoji: "⛽" },
  gasoline95: { price: 109.2, priceOld: 10920, name: "بنزين 95 (أوكتان)", unit: "لتر", emoji: "⛽" },
  diesel: { price: 90, priceOld: 9000, name: "مازوت", unit: "لتر", emoji: "🚛" },
  gasHome: { price: 1260, priceOld: 126000, name: "غاز منزلي", unit: "أسطوانة", emoji: "🏠" },
  gasIndustrial: { price: 2016, priceOld: 201600, name: "غاز صناعي", unit: "أسطوانة", emoji: "🏭" }
};
// بيانات استهلاك المركبات التقريبي
const VEHICLE_DATA = {
  cars: [
    { name: "سيارة صغيرة (اقتصادية)", consumption: 6, emoji: "🚗" },
    { name: "سيارة متوسطة", consumption: 8, emoji: "🚙" },
    { name: "سيارة كبيرة (جيب)", consumption: 12, emoji: "🚐" },
    { name: "سيارة رياضية", consumption: 15, emoji: "🏎️" },
  ],
  commercial: [
    { name: "تاكسي", consumption: 7, emoji: "🚕" },
    { name: "ميكروباص", consumption: 12, emoji: "🚌" },
    { name: "شاحنة صغيرة", consumption: 10, emoji: "🚚" },
    { name: "شاحنة كبيرة", consumption: 25, emoji: "🚛" },
  ]
};
function FuelCalculator() {
  const [fuelType, setFuelType] = useState("gasoline90");
  const [quantity, setQuantity] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  // للحساب حسب المسافة
  const [distance, setDistance] = useState("");
  const [consumption, setConsumption] = useState("");
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [distanceResult, setDistanceResult] = useState(null);
  const [distanceError, setDistanceError] = useState("");
  // التاريخ الحالي
  const today = new Date().toLocaleDateString('ar-SY', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  const calculateCost = () => {
    try {
      setError("");
      const qty = parseFloat(quantity);
      if (isNaN(qty) || qty <= 0) {
        setError("يرجى إدخال قيمة صالحة");
        return;
      }
      const fuelData = FUEL_PRICES[fuelType];
      const totalCost = qty * fuelData.price;
      const totalCostOld = qty * fuelData.priceOld;
      setResult({
        fuelName: fuelData.name,
        quantity: qty,
        unit: fuelData.unit,
        pricePerUnit: fuelData.price,
        pricePerUnitOld: fuelData.priceOld,
        totalCost: totalCost,
        totalCostOld: totalCostOld
      });
    } catch (error) {
      setError("حدث خطأ في الحساب");
    }
  };
  const calculateByDistance = () => {
    try {
      setDistanceError("");
      const dist = parseFloat(distance);
      const cons = parseFloat(consumption);
      if (isNaN(dist) || dist <= 0 || isNaN(cons) || cons <= 0) {
        setDistanceError("يرجى إدخال قيم صالحة للمسافة والاستهلاك");
        return;
      }
      const fuelData = FUEL_PRICES[fuelType];
      const litersNeeded = (dist / 100) * cons;
      const totalCost = litersNeeded * fuelData.price;
      const totalCostOld = litersNeeded * fuelData.priceOld;
      setDistanceResult({
        fuelName: fuelData.name,
        quantity: litersNeeded,
        unit: "لتر",
        pricePerUnit: fuelData.price,
        pricePerUnitOld: fuelData.priceOld,
        totalCost: totalCost,
        totalCostOld: totalCostOld,
        distance: dist,
        consumption: cons
      });
    } catch (error) {
      setDistanceError("حدث خطأ في الحساب");
    }
  };
  const handleVehicleSelect = (vehicleConsumption) => {
    setConsumption(vehicleConsumption.toString());
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px', }}>
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div className="p-3">
                <p>
                  هل تريد معرفة تكلفة البنزين لسيارتك أو حساب المازوت أو الغاز؟ حاسبة البنزين
                  والمازوت والغاز توفر لك حساباً دقيقاً لتكلفة المحروقات وفق الأسعار الرسمية
                  المعتمدة. ببساطة، أدخل الكمية من البنزين أو المازوت أو عدد أسطوانات الغاز
                  واحصل فوراً على التكلفة الإجمالية بالليرة السورية.
                </p>
                <p>
                  حاسبة المحروقات تعتمد على الأسعار الرسمية المعتمدة للبنزين 90 والبنزين 95
                  (أوكتان) والمازوت والغاز المنزلي والغاز الصناعي. سواء كنت تريد حساب البنزين
                  لرحلتك أو حساب المازوت للتدفئة أو حساب تكلفة الغاز الشهرية، الحاسبة توفر
                  لك النتائج بدقة وسرعة.
                </p>
                <p>
                  استخدم حاسبة البنزين لمعرفة تكلفة ملء خزان سيارتك، أو احسب المازوت الذي
                  تحتاجه للتدفئة، أو حدد عدد أسطوانات الغاز المنزلي التي تحتاجها شهرياً.
                  الحاسبة تساعدك على التخطيط المالي الأفضل وترشيد استهلاك البنزين والمازوت والغاز.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>⛽ حساب البنزين والمازوت والغاز في سوريا</h2>
                </div>
                <div className="bg-warning text-black text-center p-2">
                  <u><b>ملاحظة هامة</b>:</u>{" "}
                  <b>
                    تاريخ آخر تحديث: <time dateTime={new Date().toISOString().split('T')[0]}>{today}</time>
                  </b>
                </div>
                <div className="p-3">
                  <div className="form-group mb-3">
                    <label><strong>نوع المحروق:</strong></label>
                    <select
                      className="form-control"
                      value={fuelType}
                      onChange={(e) => setFuelType(e.target.value)}
                    >
                      <option value="gasoline90">⛽ بنزين 90 - {FUEL_PRICES.gasoline90.price} ل.س/لتر</option>
                      <option value="gasoline95">⛽ بنزين 95 أوكتان - {FUEL_PRICES.gasoline95.price} ل.س/لتر</option>
                      <option value="diesel">🚛 مازوت - {FUEL_PRICES.diesel.price} ل.س/لتر</option>
                      <option value="gasHome">🏠 غاز منزلي - {FUEL_PRICES.gasHome.price.toLocaleString()} ل.س/أسطوانة</option>
                      <option value="gasIndustrial">🏭 غاز صناعي - {FUEL_PRICES.gasIndustrial.price.toLocaleString()} ل.س/أسطوانة</option>
                    </select>
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="quantity">
                      <strong>الكمية ({FUEL_PRICES[fuelType].unit}):</strong>
                    </label>
                    <input
                      id="quantity"
                      type="number"
                      value={quantity}
                      onChange={(e) => setQuantity(e.target.value)}
                      className="form-control mb-2"
                      placeholder={`مثال: ${fuelType.includes('gas') ? '2' : '40'}`}
                      step="0.1"
                    />
                  </div>
                  <div className="alert alert-info">
                    <strong>💰 السعر الحالي:</strong>
                    <br />
                    {FUEL_PRICES[fuelType].price.toLocaleString()} ل.س/{FUEL_PRICES[fuelType].unit}
                    <br />
                    <small className="text-muted">
                      ({FUEL_PRICES[fuelType].priceOld.toLocaleString()} ل.س العملة القديمة)
                    </small>
                  </div>
                  <br />
                  <button
                    className="text-white"
                    style={{ fontSize: "20px", marginLeft: "10px", padding: "10px 30px", border: "none", borderRadius: "5px", backgroundColor: "#0d5e3a" }}
                    onClick={calculateCost}
                  >
                    احسب                  </button>
                </div>
                {error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  result !== null && (
                    <div className="bg-success text-white text-center">
                      <h3 style={{ fontSize: "16px", marginBottom: "15px" }}>نتيجة الحساب</h3>
                      <div style={{ fontSize: "14px", marginBottom: "15px" }}>
                        <p>
                          <strong>{result.fuelName}</strong>
                          <br />
                          {result.quantity.toFixed(2)} {result.unit} × {result.pricePerUnit.toLocaleString()} ل.س = {result.totalCost.toLocaleString()} ل.س
                          <br />
                          <small style={{ fontSize: "12px", opacity: 0.85 }}>
                            ({result.quantity.toFixed(2)} × {result.pricePerUnitOld.toLocaleString()} = {result.totalCostOld.toLocaleString()} ل.س العملة القديمة)
                          </small>
                        </p>
                        {result.distance && (
                          <p style={{ fontSize: "13px", opacity: 0.9 }}>
                            المسافة: {result.distance} كم | الاستهلاك: {result.consumption} لتر/100كم
                          </p>
                        )}
                      </div>
                      <div style={{ borderTop: "2px solid white", paddingTop: "15px" }}>
                        <p style={{ fontSize: "18px", marginBottom: "5px" }}>
                          <strong>💰 التكلفة الإجمالية</strong>
                        </p>
                        <p style={{ fontSize: "20px", marginBottom: "5px" }}>
                          🇸🇾 <strong>{result.totalCost.toLocaleString()} ل.س</strong>
                        </p>
                        <p style={{ fontSize: "13px", opacity: 0.85 }}>
                          ({result.totalCostOld.toLocaleString()} ل.س العملة القديمة)
                        </p>
                      </div>
                    </div>
                  )
                )}
              </div>
              <div className="col-sm-12 col-md-5">
                {/* جدول الأسعار الرسمية */}
                <div className="calculatorStyle">
                  <div className="bg-success text-white text-center">
                    <h3 style={{ fontSize: "16px", margin: 0 }}>📋 أسعار البنزين والمازوت والغاز</h3>
                  </div>
                  <div className="p-3">
                    <div className="mb-3">
                      <strong>⛽ البنزين والمازوت</strong>
                      <table className="table table-sm mt-2" style={{ tableLayout: "fixed" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>بنزين 90</td>
                            <td style={{ width: "50%" }}>
                              <strong>102 ل.س/لتر</strong>
                              <br />
                              <small className="text-muted">(10,200 ل.س القديمة)</small>
                            </td>
                          </tr>
                          <tr>
                            <td>بنزين 95</td>
                            <td>
                              <strong>109.2 ل.س/لتر</strong>
                              <br />
                              <small className="text-muted">(10,920 ل.س القديمة)</small>
                            </td>
                          </tr>
                          <tr>
                            <td>مازوت</td>
                            <td>
                              <strong>90 ل.س/لتر</strong>
                              <br />
                              <small className="text-muted">(9,000 ل.س القديمة)</small>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <strong>🔥 أسطوانات الغاز</strong>
                      <table className="table table-sm mt-2" style={{ tableLayout: "fixed" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>غاز منزلي</td>
                            <td style={{ width: "50%" }}>
                              <strong>1,260 ل.س</strong>
                              <br />
                              <small className="text-muted">(126,000 ل.س القديمة)</small>
                            </td>
                          </tr>
                          <tr>
                            <td>غاز صناعي</td>
                            <td>
                              <strong>2,016 ل.س</strong>
                              <br />
                              <small className="text-muted">(201,600 ل.س القديمة)</small>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <br />
                {/* أمثلة سريعة */}
                <div className="calculatorStyle">
                  <div className="bg-success text-white text-center">
                    <h3 style={{ fontSize: "16px", margin: 0 }}>🧮 أمثلة سريعة</h3>
                  </div>
                  <div className="p-3">
                    <div className="mb-2 p-2" style={{ border: "2px solid #0d5e3a", borderRadius: "5px" }}>
                      <strong>20 لتر بنزين 90:</strong>
                      <br />
                      20 × 102 = <strong>2,040 ل.س</strong>
                      <br />
                      <small className="text-muted">(204,000 ل.س العملة القديمة)</small>
                    </div>
                    <div className="mb-2 p-2" style={{ border: "2px solid #0d5e3a", borderRadius: "5px" }}>
                      <strong>50 لتر بنزين 95:</strong>
                      <br />
                      50 × 109.2 = <strong>5,460 ل.س</strong>
                      <br />
                      <small className="text-muted">(546,000 ل.س العملة القديمة)</small>
                    </div>
                    <div className="mb-2 p-2" style={{ border: "2px solid #0d5e3a", borderRadius: "5px" }}>
                      <strong>100 لتر مازوت:</strong>
                      <br />
                      100 × 90 = <strong>9,000 ل.س</strong>
                      <br />
                      <small className="text-muted">(900,000 ل.س العملة القديمة)</small>
                    </div>
                    <div className="p-2" style={{ border: "2px solid #0d5e3a", borderRadius: "5px" }}>
                      <strong>2 أسطوانة غاز منزلي:</strong>
                      <br />
                      2 × 1,260 = <strong>2,520 ل.س</strong>
                      <br />
                      <small className="text-muted">(252,000 ل.س العملة القديمة)</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {/* قسم الحساب حسب المسافة */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>
                    🚗 حساب البنزين والمازوت حسب المسافة
                  </h2>
                </div>
                <div className="p-3">
                  <div className="row">
                    <div className="col-sm-12 col-md-4">
                      <div className="form-group mb-3">
                        <label><strong>نوع الوقود:</strong></label>
                        <select
                          className="form-control"
                          value={fuelType}
                          onChange={(e) => setFuelType(e.target.value)}
                        >
                          <option value="gasoline90">⛽ بنزين 90</option>
                          <option value="gasoline95">⛽ بنزين 95</option>
                          <option value="diesel">🚛 مازوت</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-4">
                      <div className="form-group mb-3">
                        <label><strong>المسافة (كم):</strong></label>
                        <input
                          type="number"
                          value={distance}
                          onChange={(e) => setDistance(e.target.value)}
                          className="form-control"
                          placeholder="مثال: 200"
                        />
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-4">
                      <div className="form-group mb-3">
                        <label><strong>الاستهلاك (لتر/100كم):</strong></label>
                        <input
                          type="number"
                          value={consumption}
                          onChange={(e) => setConsumption(e.target.value)}
                          className="form-control"
                          placeholder="مثال: 8"
                          step="0.1"
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    className="text-white mb-3"
                    style={{ fontSize: "18px", padding: "8px 25px", border: "none", borderRadius: "5px", backgroundColor: "#0d5e3a" }}
                    onClick={calculateByDistance}
                  >
                    احسب حسب المسافة
                  </button>
                  {distanceError !== "" && (
                    <p className="p-3 mb-2 bg-warning text-white">خطأ: {distanceError}</p>
                  )}
                  {distanceResult !== null && (
                    <div className="p-3 mb-3 text-white" style={{ backgroundColor: "#0d5e3a" }}>
                      <h3 style={{ fontSize: "16px", marginBottom: "15px" }}>نتيجة الحساب حسب المسافة</h3>
                      <div style={{ fontSize: "14px", marginBottom: "15px" }}>
                        <p>
                          <strong>{distanceResult.fuelName}</strong>
                          <br />
                          المسافة: {distanceResult.distance} كم | الاستهلاك: {distanceResult.consumption} لتر/100كم
                          <br />
                          كمية الوقود: {distanceResult.quantity.toFixed(2)} {distanceResult.unit}
                          <br />
                          {distanceResult.quantity.toFixed(2)} × {distanceResult.pricePerUnit.toLocaleString()} ل.س = {distanceResult.totalCost.toLocaleString()} ل.س
                          <br />
                          <small style={{ fontSize: "12px", opacity: 0.85 }}>
                            ({distanceResult.quantity.toFixed(2)} × {distanceResult.pricePerUnitOld.toLocaleString()} = {distanceResult.totalCostOld.toLocaleString()} ل.س العملة القديمة)
                          </small>
                        </p>
                      </div>
                      <div style={{ borderTop: "2px solid white", paddingTop: "15px" }}>
                        <p style={{ fontSize: "18px", marginBottom: "5px" }}>
                          <strong>💰 التكلفة الإجمالية</strong>
                        </p>
                        <p style={{ fontSize: "20px", marginBottom: "5px" }}>
                          🇸🇾 <strong>{distanceResult.totalCost.toLocaleString()} ل.س</strong>
                        </p>
                        <p style={{ fontSize: "13px", opacity: 0.85 }}>
                          ({distanceResult.totalCostOld.toLocaleString()} ل.س العملة القديمة)
                        </p>
                      </div>
                    </div>
                  )}
                  <div className="mb-3">
                    <strong>اختر نوع المركبة (اختياري):</strong>
                  </div>
                  <div className="row">
                    {Object.entries(VEHICLE_DATA).map(([category, vehicles]) => (
                      <div className="col-sm-12 col-md-6 mb-3" key={category}>
                        <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", padding: "15px", minHeight: "180px" }}>
                          <h4 className="h6 text-center mb-3" style={{ color: "#0d5e3a", fontWeight: "bold" }}>
                            {category === 'cars' && '🚗 السيارات الخاصة'}
                            {category === 'commercial' && '🚕 المركبات التجارية'}
                          </h4>
                          <div className="d-flex flex-column gap-2">
                            {vehicles.map((vehicle) => (
                              <button
                                key={vehicle.name}
                                className="btn btn-outline-success btn-sm w-100"
                                style={{ fontSize: "13px", padding: "10px", textAlign: "center" }}
                                onClick={() => handleVehicleSelect(vehicle.consumption)}
                              >
                                {vehicle.emoji} {vehicle.name} ({vehicle.consumption} لتر/100كم)
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {/* مقارنة أنواع الوقود */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>⚖️ مقارنة تكلفة البنزين والمازوت لمسافة 1000 كم</h2>
                </div>
                <div className="p-3">
                  <div className="row">
                    {[6, 8, 10, 12].map(cons => (
                      <div className="col-sm-12 col-md-6 mb-3" key={cons}>
                        <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                          <div className="bg-success text-white text-center">
                            <strong style={{ fontSize: "14px" }}>استهلاك {cons} لتر/100كم</strong>
                          </div>
                          <div className="p-3">
                            <table className="table table-sm mb-0" style={{ fontSize: "13px" }}>
                              <tbody>
                                <tr>
                                  <td>بنزين 90</td>
                                  <td>
                                    <strong>{((1000 / 100) * cons * FUEL_PRICES.gasoline90.price).toLocaleString()} ل.س</strong>
                                    <br />
                                    <small className="text-muted">
                                      ({((1000 / 100) * cons * FUEL_PRICES.gasoline90.priceOld).toLocaleString()} ل.س قديمة)
                                    </small>
                                  </td>
                                </tr>
                                <tr>
                                  <td>بنزين 95</td>
                                  <td>
                                    <strong>{((1000 / 100) * cons * FUEL_PRICES.gasoline95.price).toLocaleString()} ل.س</strong>
                                    <br />
                                    <small className="text-muted">
                                      ({((1000 / 100) * cons * FUEL_PRICES.gasoline95.priceOld).toLocaleString()} ل.س قديمة)
                                    </small>
                                  </td>
                                </tr>
                                <tr>
                                  <td>مازوت</td>
                                  <td>
                                    <strong>{((1000 / 100) * cons * FUEL_PRICES.diesel.price).toLocaleString()} ل.س</strong>
                                    <br />
                                    <small className="text-muted">
                                      ({((1000 / 100) * cons * FUEL_PRICES.diesel.priceOld).toLocaleString()} ل.س قديمة)
                                    </small>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {/* نصائح توفير الوقود */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>💡 نصائح لتوفير استهلاك البنزين والمازوت</h2>
                </div>
                <div className="p-3">
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>حافظ على سرعة ثابتة لتوفير البنزين</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            القيادة بسرعة ثابتة (80-90 كم/س) توفر حتى 25% من استهلاك البنزين أو
                            المازوت مقارنة بالتسارع والكبح المتكرر. استخدم مثبت السرعة في الطرق السريعة
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>تحقق من ضغط الإطارات</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            الإطارات غير المنفوخة بشكل صحيح تزيد الاستهلاك بنسبة 3-5%. فحص
                            الضغط أسبوعياً يوفر الوقود ويطيل عمر الإطارات
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>خفف الحمولة الزائدة</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            كل 50 كغ إضافية تزيد الاستهلاك 2%. أفرغ صندوق السيارة من الأغراض
                            غير الضرورية وانزع الحامل العلوي إذا لم تستخدمه
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>أغلق المحرك في الانتظار</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            إذا كان الانتظار أكثر من دقيقة، أغلق المحرك. المحرك الخامل يستهلك
                            1-2 لتر/ساعة دون فائدة
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>صيانة دورية توفر البنزين والمازوت</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            تغيير الزيت والفلاتر بانتظام يحسن كفاءة المحرك بنسبة 5-10%. المحرك
                            النظيف يستهلك بنزين أو مازوت أقل ويعمل بكفاءة أعلى
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>استخدم المكيف بحكمة</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            المكيف يزيد الاستهلاك 10-20%. في السرعات المنخفضة افتح النوافذ،
                            وفي السرعات العالية استخدم المكيف (مقاومة الهواء أكبر)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>خطط طريقك لتوفير البنزين</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            تجنب ساعات الذروة والطرق المزدحمة. كل دقيقة في الزحام تهدر البنزين
                            أو المازوت. استخدم تطبيقات الملاحة لاختيار أفضل مسار
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>تسخين المحرك باعتدال</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            المحركات الحديثة لا تحتاج لتسخين طويل. 30 ثانية كافية، ثم ابدأ
                            القيادة برفق حتى يصل المحرك لحرارته المثلى
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      {/* الأسئلة الشائعة */}
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">ما الفرق بين بنزين 90 و 95؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>رقم الأوكتان</h2>
                  </u>
                  <p>
                    بنزين 95 يحتوي على نسبة أوكتان أعلى، مما يجعله أفضل للمحركات عالية
                    الضغط والسيارات الرياضية. بنزين 90 مناسب للسيارات العادية والاقتصادية.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>متى تستخدم كل نوع؟</h2>
                  </u>
                  <p>
                    استخدم البنزين الموصى به في دليل سيارتك. استخدام بنزين 95 في محرك
                    مصمم لبنزين 90 لن يحسن الأداء بشكل ملحوظ، لكنه سيكلفك أكثر.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>مثال:</strong> خزان 50 لتر
                    <br />
                    بنزين 90: 50 × 102 = 5,100 ل.س
                    <br />
                    بنزين 95: 50 × 109.2 = 5,460 ل.س
                    <br />
                    الفرق: 360 ل.س
                    <br />
                    <small className="text-muted">(36,000 ل.س العملة القديمة)</small>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيف أحسب استهلاك البنزين لسيارتي؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الطريقة الصحيحة لحساب البنزين</h2>
                  </u>
                  <p>
                    1. املأ خزان البنزين بالكامل وسجل قراءة العداد
                    <br />
                    2. قُد سيارتك بشكل طبيعي
                    <br />
                    3. عند تعبئة البنزين التالية، سجل الكمية والمسافة المقطوعة
                    <br />
                    4. احسب: (عدد لترات البنزين ÷ عدد الكيلومترات) × 100
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مثال عملي لحساب البنزين</h2>
                  </u>
                  <div className="p-3 mb-2 bg-info text-black">
                    قطعت 400 كم واستهلكت 32 لتر بنزين
                    <br />
                    الاستهلاك = (32 ÷ 400) × 100 = 8 لتر/100كم
                    <br />                    تكلفة 100 كم ببنزين 90:
                    <br />
                    8 × 102 = 816 ل.س
                    <br />
                    <small className="text-muted">(81,600 ل.س العملة القديمة)</small>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كم تدوم أسطوانة الغاز المنزلي؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>متوسط استهلاك الغاز المنزلي</h2>
                  </u>
                  <p>
                    أسطوانة الغاز المنزلي (10 كغ) تدوم في المتوسط:
                    <br />
                    • عائلة صغيرة (2-3 أشخاص): 30-45 يوماً
                    <br />
                    • عائلة متوسطة (4-5 أشخاص): 20-30 يوماً
                    <br />
                    • عائلة كبيرة (6+ أشخاص): 15-20 يوماً
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>حساب تكلفة الغاز الشهرية:</strong>
                    <br />
                    إذا كنت تستخدم أسطوانة غاز كل 25 يوم:
                    <br />
                    (30 ÷ 25) × 1,260 = 1,512 ل.س شهرياً
                    <br />
                    <small className="text-muted">(151,200 ل.س العملة القديمة)</small>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">هل المازوت أرخص من البنزين؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مقارنة أسعار المازوت والبنزين</h2>
                  </u>
                  <p>
                    نعم، المازوت أرخص من البنزين بالليتر (90 ل.س مقابل 102-109.2 ل.س).
                    لكن السيارات الديزل عادة أغلى ثمناً.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مقارنة تكلفة البنزين والمازوت لـ 10,000 كم</h2>
                  </u>
                  <div className="p-3 mb-2 bg-info text-black">
                    سيارة بنزين (8 لتر/100كم):
                    <br />
                    (10,000 ÷ 100) × 8 × 102 = 81,600 ل.س
                    <br />
                    <small className="text-muted">(8,160,000 ل.س العملة القديمة)</small>
                    <br />                    سيارة مازوت ديزل (6 لتر/100كم):
                    <br />
                    (10,000 ÷ 100) × 6 × 90 = 54,000 ل.س
                    <br />
                    <small className="text-muted">(5,400,000 ل.س العملة القديمة)</small>
                    <br />                    <strong>التوفير: 27,600 ل.س</strong>
                    <br />
                    <small className="text-muted">(2,760,000 ل.س العملة القديمة)</small>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيف أقلل من استهلاك البنزين والمازوت؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>أهم 5 نصائح لتوفير البنزين والمازوت</h2>
                  </u>
                  <p>
                    1. <strong>قيادة هادئة:</strong> تجنب التسارع والكبح المفاجئ - توفير 20% من البنزين
                    <br />
                    2. <strong>السرعة المثلى:</strong> حافظ على 80-90 كم/س - توفير 15% من البنزين
                    <br />
                    3. <strong>ضغط الإطارات:</strong> فحص أسبوعي - توفير 5% من البنزين
                    <br />
                    4. <strong>تخفيف الحمولة:</strong> أزل الأغراض غير الضرورية - توفير 3%
                    <br />
                    5. <strong>صيانة دورية:</strong> تغيير الزيت والفلاتر - توفير 10% من البنزين
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>مثال توفير البنزين:</strong> سيارة تستهلك 10 لتر بنزين/100كم
                    <br />
                    بتطبيق هذه النصائح: 10 × 0.50 = 5 لتر بنزين توفير
                    <br />
                    لمسافة 1000 كم شهرياً:
                    <br />
                    50 لتر بنزين × 102 ل.س = 5,100 ل.س توفير شهري!
                    <br />
                    <small className="text-muted">(510,000 ل.س العملة القديمة)</small>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">ما الفرق بين الغاز المنزلي والصناعي؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الفرق الأساسي</h2>
                  </u>
                  <p>
                    <strong>الغاز المنزلي:</strong> أسطوانة 10 كغ، مخصصة للاستخدام المنزلي
                    (الطبخ، التدفئة المنزلية). السعر: 1,260 ل.س
                  </p>
                  <p>
                    <strong>الغاز الصناعي:</strong> أسطوانة أكبر (عادة 20-25 كغ)، مخصصة
                    للاستخدام التجاري والصناعي (المطاعم، المخابز، الورش). السعر: 2,016 ل.س
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>السعر لكل كيلو:</strong>
                    <br />
                    غاز منزلي: 1,260 ÷ 10 = 126 ل.س/كغ
                    <br />
                    غاز صناعي: 2,016 ÷ 20 = 100.8 ل.س/كغ (تقريباً)
                    <br />
                    <small className="text-muted">
                      (غاز منزلي: 12,600 ل.س/كغ قديمة | غاز صناعي: 10,080 ل.س/كغ قديمة)
                    </small>
                    <br />                    الغاز الصناعي أوفر للكمية، لكن يتطلب ترخيص للشراء
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default FuelCalculator;